const config = __CONFIG__

export const getIsCaptchaEnabled = () => {
    return config.NV_HCAPTCHA_ENABLED !== 'false'
}
